import { makeStyles } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'

export const useNonProfitsComponentStyles = makeStyles(() =>
  createStyles({
    filterContainer: {
      marginTop: '0px',
      position: 'relative',
      zIndex: 999,
    },
  })
)
